import ExpandMore from "@mui/icons-material/ExpandMore";
import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from "@mui/material";

const CollapsibleCard = ({
  children,
  showContent,
  defaultExpanded,
  noExapandCollapse,
  onExpand,
}) => {
  return (
    <Accordion
      onChange={(_e, isExpanded) =>
        isExpanded && onExpand ? onExpand() : null
      }
      defaultExpanded={defaultExpanded}
      className="mb-2"
      elevation={1}
    >
      <AccordionSummary
        expandIcon={noExapandCollapse ? null : <ExpandMore />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Box
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          className="w-full"
        >
          {showContent}
        </Box>
      </AccordionSummary>
      <AccordionDetails className="mx-2 py-2 border-t">
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default CollapsibleCard;
